import { ITERATION_STATUS } from 'schemas/CampaignApiDetails.schema';
import { IterationDetails } from 'schemas/CampaignConfig.schema.ts';

export const canRejectApprove = (
  canApproveCampaign: boolean,
  iterationDetails: IterationDetails | undefined,
  userId: string,
) => {
  if (!canApproveCampaign) {
    return false;
  }

  if (iterationDetails?.status?.toLowerCase() !== ITERATION_STATUS.IN_REVIEW) {
    return false;
  }

  if (!iterationDetails?.reviewers?.includes(userId)) {
    return false;
  }

  if (iterationDetails?.submitted_by === userId) {
    return false;
  }

  return true;
};

export const canRevertToDraft = (
  canUpdateCampaign: boolean,
  iterationDetails: IterationDetails | undefined,
  userId: string,
) => {
  if (!canUpdateCampaign) {
    return false;
  }

  const status = iterationDetails?.status?.toLowerCase();

  if (status === ITERATION_STATUS.SENT_TO_NHS_NOTIFY || status === ITERATION_STATUS.DRAFT) {
    return false;
  }

  if (status === ITERATION_STATUS.IN_REVIEW && iterationDetails?.reviewers?.includes(userId)) {
    return false;
  }

  return true;
};

export const canSendForReview = (
  canUpdateCampaign: boolean,
  iterationDetails: IterationDetails | undefined,
  userId: string,
) => {
  if (!canUpdateCampaign) {
    return false;
  }

  if (iterationDetails?.status?.toLowerCase() !== ITERATION_STATUS.DRAFT) {
    return false;
  }

  if (iterationDetails?.locked_by?.id && iterationDetails.locked_by.id !== userId) {
    return false;
  }

  return true;
};

export const isRevertToDraftGreenColour = (iterationDetails: IterationDetails | undefined) => iterationDetails?.status?.toLowerCase() === ITERATION_STATUS.REJECTED
  || iterationDetails?.status?.toLowerCase() === ITERATION_STATUS.REPORT_REJECTED;

export const canArchive = (
  canUpdateCampaign: boolean,
  iterationDetails: IterationDetails | undefined,
  userId: string,
) => {
  if (!canUpdateCampaign) {
    return false;
  }

  const status = iterationDetails?.status?.toLowerCase();

  if (status !== ITERATION_STATUS.DRAFT) {
    return false;
  }

  if (iterationDetails?.locked_by?.id !== userId) {
    return false;
  }

  return true;
};
